<template>
    <v-container grid-list-lg fluid >
        
            <v-row>
                <h3>Recordatorios</h3>
                <v-spacer></v-spacer>
                <v-btn @click="load" small text>Refrescar</v-btn>
            </v-row>
            <v-divider></v-divider>

            <v-flex xs12>
                <v-container fluid grid-list-lg>
                    <v-row v-for="item in listaRecordatorios" :key="item.descripcion" dense align="center">
                        <v-col>
                            <span>{{item.descripcion}}</span>
                        </v-col>
                        <v-col cols="2">
                            <v-chip hover  small label dense dark :color="item.color">{{item.cantidad}}</v-chip>
                        </v-col>
                    </v-row>
                    
                </v-container>
                <v-row>
                </v-row>
            </v-flex>
              
    </v-container>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: function () {
    return {      
      listaRecordatorios: [],
    }
  },
  created () {
    this.load();
  },
  watch: {    
    '$store.state.UiConfig' (){
      
    },
  },
  computed: {
    ...mapGetters(['getActionFromLink','user']),
  },
  methods:{
      ...mapMutations(['alertError']),
    ...mapActions(['setStatusTareaFrecuente']),      
    async load(){
      this.loading = true;

      console.log(this.user)
      try{
        var result = await http.get('gestion/getresumenporgestor?gestor='+this.user.login);

        this.listaRecordatorios = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
  }
}
</script>

<style scoped>
  
  .item {
    min-height: 110px;
    max-height: 110px;
    min-width: 80px;
    margin: 5px;
  }
</style>
